import React, { useState, useEffect, SyntheticEvent } from 'react'
import { Link, useHistory } from 'react-router-dom'
import assets from '../admin/crudFunctions/assets'
import { client, location } from '../interfaces'

interface form {
  client: client
  method: string
  location: location | string
  transaction_number: string
  amount: string
  date: string
}

const Form = () => {
  const [method, setMethod] = useState<string>('')
  const [location, setLocation] = useState<location | string>('')
  const [locationList, setLocationList] = useState<location[] | null>(null)
  const [transactionNumber, setTransactionNumber] = useState<string>('')
  const [copAmount, setCopAmount] = useState<string>('')
  const [usdAmount, setUsdAmount] = useState<string>('')
  const [bsAmount, setBsAmount] = useState<string>('')
  const [isBs, setIsBs] = useState<boolean>(false)
  const [date, setDate] = useState<string>('')
  const [isLocation, setIsLocation] = useState<boolean>(false)
  const [isTransaction, setIsTransaction] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const [isZelle, setIsZelle] = useState<boolean>(false)
  const [zelleAccount, setZelleAccount] = useState<string>('')
  const history: any = useHistory()
  const client: client = history.location.state.client
  // endpoint url to serverless function
  const endpoint: string = 'getData?endpoint=location/list'
  const url: string = assets.serverlessUrl + endpoint

  const getLocationList = async (url: string): Promise<location[]> => {
    const response: Response = await fetch(url)
    return response.json()
  }

  const handleChange = (e: any) => {
    const id = e.target.value

    const locationObj = locationList!.find(
      (location: location) => location.id === parseInt(id)
    )

    setLocation(locationObj!)
  }

  const handleSubmit = (e: SyntheticEvent): void => {
    e.preventDefault()
    if (
      method &&
      date &&
      (copAmount || usdAmount || bsAmount) &&
      (location ||
        (method === 'Bancos Nacionales' && transactionNumber) ||
        (method === 'Zelle' && transactionNumber && zelleAccount))
    ) {
      let finalAmount = ''
      if (usdAmount && copAmount) {
        finalAmount = `${usdAmount}USD y ${copAmount}COP`
      } else if (usdAmount) {
        finalAmount = `${usdAmount}USD`
      } else {
        finalAmount = `${copAmount}COP`
      }
      const form: form = {
        client: client,
        method: method,
        location: location,
        transaction_number: transactionNumber,
        amount: finalAmount,
        date: date
      }

      if (method === 'Bancos Nacionales') {
        form.amount = `${bsAmount} Bolivares`
      } else if (method === 'Zelle') {
        form.method = zelleAccount
      }

      history.push({
        pathname: '/verification',
        state: { form: form }
      })
    } else {
      setIsError(true)
    }
  }

  useEffect(() => {
    getLocationList(url).then((response: location[]) => {
      setLocationList(response)
    })
  }, [url])

  useEffect(() => {
    if (method === 'Efectivo en Divisas') {
      setIsLocation(true)
      setIsTransaction(false)
      setTransactionNumber('')
      setIsBs(false)
      setBsAmount('')
      setIsZelle(false)
      setZelleAccount('')
    } else if (method === 'Zelle' || method === 'Bancos Nacionales') {
      setIsLocation(false)
      setIsTransaction(true)
      setLocation('')
      if (method === 'Bancos Nacionales') {
        setIsZelle(false)
        setIsBs(true)
        setUsdAmount('')
        setCopAmount('')
        setZelleAccount('')
      } else {
        setIsBs(false)
        setIsZelle(true)
      }
    }
  }, [method])

  return (
    <React.Fragment>
      <div className='container grid justify-items-center md:mx-auto'>
        <form className='grid mt-8' onSubmit={handleSubmit}>
          <label htmlFor='method' className='text-2xl'>
            Método de Pago
          </label>
          <select
            name='method'
            id='method'
            defaultValue={''}
            className='bg-white border-solid border-2 border-black rounded-full h-14 w-80 text-center text-2xl mb-8'
            onChange={(e) => setMethod(e.target.value)}>
            <option value='' className='pl-4' disabled>
              Seleccione...
            </option>
            <option value='Efectivo en Divisas'>Efectivo en Divisas</option>
            <option value='Zelle'>Zelle</option>
            <option value='Bancos Nacionales'>Bancos Nacionales</option>
          </select>

          {isZelle && (
            <>
              <label htmlFor='zelleAccount' className='text-2xl'>
                Cuenta a la que transfirió:
              </label>
              <select
                name='zelleAccount'
                id='zelleAccount'
                defaultValue={''}
                className='bg-white border-solid border-2 border-black rounded-full h-14 w-80 text-center text-2xl mb-8'
                onChange={(e) => setZelleAccount(e.target.value)}>
                <option value='' className='pl-4' disabled>
                  Seleccione...
                </option>
                <option value='Zelle Alba'>Zelle Alba</option>
                <option value='Zelle Manuel'>Zelle Manuel</option>
                <option value='Zelle Williamrosadoro'>Zelle Williamrosadoro</option>
                <option value='Zelle wrosadoro'>Zelle wrosadoro</option>
              </select>
            </>
          )}

          {isLocation && (
            <>
              <label htmlFor='location' className='text-2xl'>
                Dirección
              </label>
              <select
                name='location'
                id='location'
                defaultValue={''}
                className='bg-white border-solid border-2 border-black rounded-full h-14 w-80 text-center text-2xl mb-8'
                onChange={(e) => handleChange(e)}>
                <option value='' disabled>
                  Seleccione...
                </option>
                {locationList!.map((location: location) => {
                  return (
                    <option value={location.id} key={location.id}>
                      {location.address}
                    </option>
                  )
                })}
              </select>
            </>
          )}
          {isTransaction && (
            <>
              <label htmlFor='transaction_number' className='text-2xl'>
                Nro. Referencia
              </label>
              <input
                type='text'
                name='transaction_number'
                id='transaction_number'
                placeholder='ABC123'
                className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-8'
                onChange={(e) => setTransactionNumber(e.target.value)}
              />
            </>
          )}

          {isBs ? (
            <>
              <label htmlFor='usdAmount' className='text-2xl'>
                Bolívares
              </label>

              <input
                type='text'
                name='bsAmount'
                id='bsAmount'
                value={bsAmount}
                placeholder='0'
                className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl'
                onChange={(e) => setBsAmount(e.target.value.replace(/\D/, ''))}
              />
            </>
          ) : (
            <>
              <label htmlFor='usdAmount' className='text-2xl'>
                Dólares
              </label>

              <input
                type='text'
                name='usdAmount'
                id='usdAmount'
                value={usdAmount}
                placeholder='0'
                className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl'
                onChange={(e) => setUsdAmount(e.target.value.replace(/\D/, ''))}
              />

              <label htmlFor='copAmount' className='text-2xl mt-5'>
                Pesos
              </label>

              <input
                type='text'
                name='copAmount'
                id='copAmount'
                value={copAmount}
                placeholder='0'
                className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl'
                onChange={(e) => setCopAmount(e.target.value.replace(/\D/, ''))}
              />
            </>
          )}

          <span className='text-lg text-center mb-5'>
            Sin comas,puntos, decimales, simbolos
          </span>

          <label htmlFor='paymentDate' className='text-2xl'>
            Fecha del Pago
          </label>

          <input
            type='date'
            name='paymentDate'
            id='paymentDate'
            placeholder='0'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-5'
            onChange={(e) => setDate(e.target.value)}
          />

          {isError && (
            <h2 className='text-xl text-center place-self-center w-3/4 text-red-500 mb-10'>
              Debe completar todos los campos
            </h2>
          )}

          <button
            type='submit'
            className='bg-black active:bg-gray-800 rounded-full h-14 w-80 text-center text-white text-3xl mb-20'>
            Siguiente
          </button>
        </form>

        <Link to='/'>
          <button
            type='button'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-3xl'>
            Cancelar
          </button>
        </Link>
      </div>
    </React.Fragment>
  )
}

export default Form
